module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('span', [_vm._v("第二个头部")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-3e05ac5c"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/HeadNav2/HeadNav2.vue
// module id = 90
// module chunks = 1